import CopyToClipboard from 'react-copy-to-clipboard';
import { CopyProps } from './props';
import { Input } from '@starsoft/common/components';
import styles from './styles.module.scss';

/**
 * Component that provides copy to clipboard functionality with a styled input
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.textToCopy - Text that will be copied to clipboard when clicked
 * @param {string} props.label - Text to display in the input field
 * @param {boolean} props.isLoading - Whether to show loading state
 * @param {boolean} props.secondaryStyles - Whether to use secondary container color style
 * @param {Function} props.callback - Optional callback function called after successful copy
 * @returns {JSX.Element} Input field with copy functionality
 */
export function Copy({
  textToCopy,
  label,
  isLoading = false,
  secondaryStyles,
  callback,
  customIcon,
}: CopyProps) {
  /**
   * Handles the copy action
   * Calls the callback function if provided
   */
  function handleCopy() {
    if (typeof callback == 'undefined') {
      return;
    }

    callback();
  }

  // Show loading state if isLoading is true
  if (isLoading) {
    return <Input isLoading />;
  }

  return (
    <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
      {/* @ts-ignore */}
      <div className={styles.container}>
        <Input
          value={label}
          readOnly
          rightIcon={`${customIcon} fa-solid fa-copy`}
          hasPaddingRight
          isContainerColor={secondaryStyles}
        />
      </div>
    </CopyToClipboard>
  );
}
